<template>
  <div class="d-flex align-center justify-space-between">
    <Title title="Administrador" />
    <AdminButtonModal />
  </div>
</template>

<script>
import Title from "@/components/atoms/title";
import AdminButtonModal from "@/components/other/Modals/new-admin-modal";

export default {
  components: { Title, AdminButtonModal }
};
</script>